// Mirrors FilterCollapse's collapsed row shape (min-h-[65px], bordered) so the
// skeleton doesn't shift layout once real filters replace it. Same visual
// language as SkeletonCard.js: animate-pulse + bg-page-secondary blocks, no
// shimmer/gradient sweep.
const SKELETON_ROW_COUNT = 5

export function FilterSkeleton() {
  return (
    <div className="flex flex-col">
      {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
        <div
          key={index}
          className="flex items-center justify-between gap-x-0.75 min-h-[65px] px-margin py-1.5 border-b border-borders-default"
        >
          <div className="h-1 w-[35%] bg-page-secondary animate-pulse"></div>
          <div className="size-[14px] bg-page-secondary animate-pulse"></div>
        </div>
      ))}
    </div>
  )
}
